(function () {
  if (window.__deenPdpUpsells) return;
  window.__deenPdpUpsells = true;

  function feedback(btn, label, text, restore) {
    if (!btn) return;
    btn.textContent = text;
    if (restore) setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 1800);
  }
  function announce() {
    try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
    if (typeof window.deenCartRefresh === 'function') { try { window.deenCartRefresh(); } catch (e) {} }
  }
  function postItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });
  }
  function currentVariantId(root) {
    var f = document.querySelector('form[data-type="add-to-cart-form"] [name="id"]');
    if (f && f.value) return Number(f.value);
    return Number(root.getAttribute('data-fallback-variant')) || 0;
  }
  function selectedVariant(card) {
    var f = card.querySelector('[name="id"]');
    return f && f.value ? Number(f.value) : 0;
  }
  function paintPrice(card, v) {
    if (!v) return;
    var now = card.querySelector('[data-deen-upsell-now]');
    var was = card.querySelector('[data-deen-upsell-was]');
    if (now) now.textContent = v.price || '';
    if (was) {
      if (v.compare) { was.textContent = v.compare; was.hidden = false; }
      else { was.textContent = ''; was.hidden = true; }
    }
  }
  function initCard(card) {
    if (card.__deenUpsellReady) return;
    var holder = card.querySelector('[data-deen-upsell-data]');
    var sizeInput = card.querySelector('[data-deen-upsell-size]');
    var sizeSelect = card.querySelector('[data-deen-upsell-size-select]');
    var colourSelect = card.querySelector('[data-deen-upsell-colour-select]');
    if (!holder || !sizeInput || !sizeSelect) return;
    var data;
    try { data = JSON.parse(holder.textContent); } catch (e) { return; }
    var colours = data.colours || [];
    if (!colours.length) return;
    card.__deenUpsellReady = true;
    /* The cart drawer listens for change/input on everything inside it and treats it as a quantity edit (that caused "increments of undefined"). These selects are not quantities, so keep their events to themselves. */
    [sizeSelect, colourSelect].forEach(function (s) {
      if (!s) return;
      ['change', 'input'].forEach(function (t) { s.addEventListener(t, function (e) { e.stopPropagation(); }); });
    });
    function findVariant(id) {
      for (var i = 0; i < colours.length; i++)
        for (var j = 0; j < colours[i].variants.length; j++)
          if (Number(colours[i].variants[j].id) === Number(id)) return colours[i].variants[j];
      return null;
    }
    function selectSize(id) {
      var v = findVariant(id);
      if (!v) return;
      sizeInput.value = v.id;
      sizeSelect.value = String(v.id);
      paintPrice(card, v);
    }
    function buildSizes(colour) {
      sizeSelect.innerHTML = '';
      if (!colour || !colour.variants || !colour.variants.length) { sizeInput.value = ''; return; }
      colour.variants.forEach(function (v) {
        var o = document.createElement('option');
        o.value = String(v.id); o.textContent = v.label;
        sizeSelect.appendChild(o);
      });
      selectSize(colour.variants[0].id);
    }
    function paintColour(i) {
      var c = colours[i];
      if (!c) return;
      if (colourSelect) colourSelect.value = String(i);
      buildSizes(c);
      var img = card.querySelector('.deen-upsell__img');
      if (img && c.img) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = c.img; }
      Array.prototype.forEach.call(card.querySelectorAll('[data-deen-upsell-link]'), function (l) { l.href = c.url; });
    }
    if (colourSelect) colourSelect.addEventListener('change', function () { paintColour(Number(colourSelect.value)); });
    sizeSelect.addEventListener('change', function () { selectSize(sizeSelect.value); });
    paintColour(Number(data.defaultIndex) || 0);
  }
  var ARROW_PREV = '<svg viewBox="0 0 8 12" fill="none" aria-hidden="true"><path d="M6.5 1L1.5 6l5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ARROW_NEXT = '<svg viewBox="0 0 8 12" fill="none" aria-hidden="true"><path d="M1.5 1l5 5-5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function initSlider(root) {
    if (root.__deenSlider || !root.closest('.product__info-container')) return;
    var row = root.querySelector('.deen-upsell__row');
    if (!row) return;
    root.__deenSlider = true;
    var wrap = document.createElement('div');
    wrap.className = 'deen-upsell__slider';
    row.parentNode.insertBefore(wrap, row);
    wrap.appendChild(row);
    function mk(cls, label, svg, dir) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'deen-upsell__arrow ' + cls; b.setAttribute('aria-label', label); b.innerHTML = svg;
      b.addEventListener('click', function () { row.scrollBy({ left: dir * (row.clientWidth * 0.6), behavior: 'smooth' }); });
      wrap.appendChild(b);
    }
    mk('deen-upsell__arrow--prev', 'Previous', ARROW_PREV, -1);
    mk('deen-upsell__arrow--next', 'Next', ARROW_NEXT, 1);
    function update() {
      var max = row.scrollWidth - row.clientWidth - 2;
      wrap.classList.toggle('has-prev', row.scrollLeft > 2);
      wrap.classList.toggle('has-next', row.scrollLeft < max);
    }
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    setTimeout(update, 400);
  }
  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.deen-upsell__card'), initCard);
    Array.prototype.forEach.call(document.querySelectorAll('[data-deen-upsell-root]'), initSlider);
  }
  window.deenUpsellsInit = initAll;
  initAll();
  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('.deen-upsell__form')) return;
    e.preventDefault();
    var f = form.querySelector('[name="id"]');
    if (!f || !f.value) return;
    var btn = form.querySelector('[data-deen-upsell-btn]');
    var label = btn ? btn.textContent.trim() : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    postItems([{ id: Number(f.value), quantity: 1 }])
      .then(function () { announce(); feedback(btn, label, 'Added', true); })
      .catch(function () { feedback(btn, label, 'Try again', true); });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-deen-bundle-btn]') : null;
    if (!btn) return;
    var root = btn.closest('[data-deen-upsell-root]');
    if (!root) return;
    var B = { id: root.dataset.bundleId, deal: root.dataset.bundleDeal, bid: root.dataset.bundleBid, v: root.dataset.bundleVersion };
    var label = btn.textContent.trim();
    var items = [], missing = false;
    Array.prototype.forEach.call(root.querySelectorAll('.deen-upsell__card'), function (card) {
      var vid = selectedVariant(card);
      if (!vid) { missing = true; return; }
      items.push({ id: vid, quantity: 1, properties: { __kaching_bundles: JSON.stringify({ id: B.id, deal: B.deal, v: B.v, collectionBreaksProduct: true }) } });
    });
    var own = currentVariantId(root);
    if (missing || items.length !== 2 || !own) { feedback(btn, label, 'Pick a size', true); return; }
    items.push({ id: own, quantity: 1, properties: { __kaching_bundles: JSON.stringify({ id: B.id, deal: B.deal, v: B.v, main: true, bid: B.bid, pp: Number(root.getAttribute('data-product-id')) }) } });
    btn.disabled = true; btn.textContent = 'Adding…';
    postItems(items)
      .then(function () { announce(); feedback(btn, label, 'Added all 3', true); })
      .catch(function () { feedback(btn, label, 'Try again', true); });
  });
})();